import React, { createContext, useContext } from 'react';
import type { WizardContext, WizardStepId } from './types';

export type NavContextValue = Pick<
  WizardContext,
  'goNext' | 'goBack' | 'goTo' | 'cancel'
>;

const WizardNavContext = createContext<NavContextValue | undefined>(undefined);

export function WizardNavProvider({
  value,
  children,
}: {
  value: NavContextValue;
  children: React.ReactNode;
}) {
  return (
    <WizardNavContext.Provider value={value}>
      {children}
    </WizardNavContext.Provider>
  );
}

export function useWizardNav(): NavContextValue {
  const ctx = useContext(WizardNavContext);
  if (!ctx)
    throw new Error('useWizardNav must be used within WizardNavProvider');
  return ctx;
}
